import { AppRoutes } from '@constants/app-routes'
import { Link } from '@ui/links/Link'
import { OrangeLink } from '@ui/links/OrangeLink'

export const config = {
  titleTitleSection: 'A platform for\nimproving\ndiagnostic\naccuracy',
  client: {
    titleClient: 'Client',
    subtitleClient:
      'A well-established and trusted German cancer care clinic operating in the healthcare industry since 2010 contacted\nModsen team with a view to finding expert engineers with a proven track record in implementing AI solutions for\nMedTech. The key activity of our partner consisted in the provision of personalized and prognostic data for cancer\npatient examination and diagnosis which could be significantly improved with the incorporation of advanced\ntechnologies. ',
    clientImage: {
      src: `/images/cases/client-ai-based-platform.webp`,
      alt: 'Advertising app interface',
      title: 'Advertising app interface',
      width: 762,
      height: 572,
    },
  },

  marketAnalysisTechnologies: [
    {
      id: 'Challenge',
      title: 'Challenge',
      subtitle:
        'Lack of in-house expertise in leveraging AI technology for MedTech and pressing need for fast onboarding of specialists.',
      alt: 'Hexagon image',
    },
    {
      id: 'Solution',
      title: 'Solution',
      subtitle:
        'Incorporation of 6 Modsen engineers into the internal team to aid out client build an AI-driven online platform foe accurate patient diagnosing and treatment.',
      alt: 'Hexagon image',
    },
    {
      id: 'Tech stack',
      title: 'Tech stack',
      subtitle: (
        <>
          Java, AWS, PostgreSQL,{' '}
          <Link href={AppRoutes.react} target="blank">
            React
          </Link>
          , AI.
        </>
      ),
      alt: 'Hexagon image',
    },
  ],
  challengeSectionList: [
    {
      title:
        'In recent years, our client more and more often rendered services related to diagnosing the most complicated cancer cases. As a rule, experience from millions of cancer patients can help make the best treatment decision in such cases.\n\nOur client set a socially significant goal to consolidate the patient data they already had with many new cases. For this, they needed their own software product powered by artificial intelligence.\n\nModsen’s software developers joined the client’s small in-house team to address the following challenges:',
      value: [
        'fast integration into the project at the initial stage and launch of the product within 6 months;',
        'analysis of an extensive database using SQL Server;',
        'algorithm development for data-report generation; clear structuring of prognoses and treatment plans;',
        'creation of an API to communicate with the client’s database;',
        'strict consideration of all data available and configuration of the most accurate patient treatment prognosis.',
      ],
    },
  ],
  solutionSectionList: [
    {
      title: (
        <>
          Joining the project,{' '}
          <OrangeLink href={AppRoutes.scaleYourTeam}>
            Modsen’s software development team
          </OrangeLink>{' '}
          had to meet two important conditions: rapid software development and
          solid control of the project team to ensure effectiveness and meeting
          the deadlines.
          <br />
          <br />
          Our project team of 6 developers brought in their vision of an
          effective build of the project management, proper control, and
          achievement of all KPI values.
          <br />
          <br />
          The Modsen’s developers added the required tech stack and{' '}
          <OrangeLink href={AppRoutes.medtech}>
            medicine- specific software development{' '}
          </OrangeLink>
          experience to the project and helped launch the project within 6
          months. The team did the following:
        </>
      ),
      value: [
        'developed a large web portal for collection, management, and provision of patient data at the diagnosis stage and throughout the entire treatment period',
        'integrated components allowing the patients to access the prognostic analytics and data from several hundreds of thousands of patients',
        'improved the quality of the prognostic algorithms by adding various factors, such as age, sex, concomitant chronic diseases, and disease stage',
        'added a possibility to track patient condition over time, and thereby ensured individual understanding of a patient’s condition and functioning in real time',
      ],
    },
  ],
}
export const TableSectionConfig = [
  {
    id: 'Challenge',
    title: 'Challenge',
    subtitle:
      'Lack of in-house expertise in leveraging AI technology for MedTech and pressing need for fast onboarding of specialists.',
    alt: '',
  },
  {
    id: 'Solution',
    title: 'Solution',
    subtitle:
      'Incorporation of 6 Modsen engineers into the internal team to aid out client build an AI-driven online platform foe accurate patient diagnosing and treatment.',
    alt: '',
  },
  {
    id: 'Tech stack',
    title: 'Tech stack',
    subtitle: (
      <>
        Java, AWS, PostgreSQL, <Link href={AppRoutes.react}>React</Link>, AI.
      </>
    ),
    alt: '',
  },
]
